// extracted by mini-css-extract-plugin
export var animationContainer = "_fn-0";
export var asteriskIcon = "_fn-8";
export var conversationLeftSection = "_fn-4";
export var conversationListItem = "_fn-3";
export var conversationMiddleSection = "_fn-5";
export var conversationRightSection = "_fn-6";
export var detailsContent = "_fn-1";
export var listContainer = "_fn-7";
export var modalContent = "_fn-2";